import { atom } from "jotai"
import { VisualEncodingProps } from "./types"

export const fillScaleState = atom<VisualEncodingProps>({})
